import { IIssueBoardApi } from "@schemas/issueBoardSchema";
import {
  GetProjectByProjectIdIssuesOnBoardApiArg,
  useGetProjectByProjectIdIssuesOnBoardQuery,
} from "../../../../../../openapi";
import IssueMobileViewDefault from "./IssueMobileViewDefault";
import IssueMobileViewSJA from "./IssueMobileViewSJA";

const IssueMobileView = ({ issueBoard }: { issueBoard: IIssueBoardApi }) => {
  const isSJA = issueBoard.madeFromTemplate?.title?.startsWith("SJA");

  const args: GetProjectByProjectIdIssuesOnBoardApiArg = {
    projectId: issueBoard.project,
    issueboardId: issueBoard._id,
    includeIssues: isSJA === true ? "false" : "true",
    includeTasks: isSJA === true ? "true" : "false",
  };

  const { data: issuesOnBoard } = useGetProjectByProjectIdIssuesOnBoardQuery(args, {
    skip: args.projectId == null || args.issueboardId == null,
  });

  return (
    <>
      {issueBoard.madeFromTemplate.title.startsWith("SJA") ? (
        <IssueMobileViewSJA />
      ) : (
        <IssueMobileViewDefault issues={issuesOnBoard} openContent={() => {}} />
      )}
    </>
  );
};

export default IssueMobileView;
